import './popup_promocao.css'
import Icon from '@mdi/react';
import {mdiArrowRight, mdiClose, mdiGift} from '@mdi/js';
import relatorio_demo from './relatorio_demo.png'
import { useNavigate } from 'react-router-dom';

export default function PopupPromocao({setPopupPromocao, popupPromocao, naoMostrarMais, closePromotion24h}) {
    /*IMPLEMENTAR LOGIN GOOGLE*/

    const navigate = useNavigate();

  return (
    popupPromocao && 
    <div className="popup_promocao">
        <div className='popup_promocao-box'>
            <div className="popup-content">
                <span className='tag'><Icon path={mdiGift} size={0.7} />Oferta de boas-vindas</span>
                <h1>Cadastre-se e ganhe <span>1 crédito</span></h1>
                <h2>para desbloquear um relatório Premium</h2>
                <p>Descubra se o bairro é bom para morar com dados reais de segurança, mobilidade e infraestrutura.</p>
                
                <button onClick={()=>{naoMostrarMais(); navigate("/Cadastro");}} >Criar sua conta<Icon path={mdiArrowRight} size={0.75} /></button>
            </div>
            
            <button onClick={()=>{setPopupPromocao(false); closePromotion24h()}} className="close-bt"><Icon path={mdiClose} size={1} /></button>

            <img src={relatorio_demo} alt="demo_relatório" />
        </div>
        
       
    </div>
    );
}
